module.exports = __webpack_public_path__ + "Simple-Line-Icons.ff94ad94c3a9d04bd2f8.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons/fonts/Simple-Line-Icons.woff
// module id = ../../../../../src/assets/fonts/line-icons/fonts/Simple-Line-Icons.woff
// module chunks = styles